export const getUnitRoute = (
  programId = ':programId',
  id = ':id',
  search = '',
) => `/program/${programId}/unit/${id}/${search}`;

export const getModuleRoute = (
  programId = ':programId',
  id = ':id',
  search = '',
) => `/program/${programId}/module/${id}/${search}`;

export const getContentRoute = (
  programId = ':programId',
  id = ':id',
  search = '',
) => `/program/${programId}/content/${id}/${search}`;
